let $ = require('jquery');
let template = require('templates/modal.hbs');

module.exports = (options) => {
    options = Object.assign({
        primaryButton: 'Ok',
        secondaryButton: 'Fechar',
        width: 400,
        primaryButtonClass: 'blue',
        secondaryButtonClass: 'btn-default'
    }, options);

    let {
        title,
        content,
        primaryButton,
        primaryButtonClass,
        onPrimaryButton,
        secondaryButton,
        secondaryButtonClass,
        onSecondaryButton,
        onShown,
        onShow,
        onClosed,
        onClose,
        width
    } = options;

    let modal = template(options);
    let $modal = $(modal);

    $modal.on('show.bs.modal', function () {
        if (onShow) onShow($modal);
    });

    $modal.on('shown.bs.modal', function () {
        if (onShown) onShown($modal);
    });

    $modal.on('hide.bs.modal', function () {
        if (onClose) onClose($modal);
    });

    $modal.on('hidden.bs.modal', function () {
        if (onClosed) onClosed($modal);
        $modal.remove();
    });

    $modal.modal({
        width
    });

    $modal.find('.primary-button').click(function () {
        if (onPrimaryButton) {
            onPrimaryButton($modal, function () {
                $modal.modal('hide');
            });
        } else {
            $modal.modal('hide');
        }
    });

    $modal.find('.secondary-button').click(function () {
        if (onSecondaryButton) {
            onSecondaryButton($modal, function () {
                $modal.modal('hide');
            });
        } else {
            $modal.modal('hide');
        }
    });

    $modal.on('modal.close', function () {
        $modal.modal('hide');
    });

    $modal.on('modal.body-changed', function (event, content) {
        $modal
            .find('.modal-body')
            .html(content);
    });

    return $modal;
};



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/helpers/modal.js